import useScale from './useScale';

export default useScale;
